<template>
  <div class="payment">
   
    <a-spin :spinning="paySpinning">
      <!-- v-if="params" -->
      <div  class="content" v-if="params">
        <div class="pays">
          <h1 class="text-center paytitle">缴费信息</h1>
          <div class="tablebg">
            <table class="table table-hover">
              <tr>
                <td class="table-td1">姓名</td>
                <td class="table-td">{{ params.body }}</td>
              </tr>
              <tr>
                <td class="table-td1">学校</td>
                <td class="table-td">{{ userInfo.eduName }}</td>
              </tr>
              <tr>
                <td class="table-td1">层次</td>
                <td class="table-td">{{ userInfo.learnLevel }}</td>
              </tr>
              <tr>
                <td class="table-td1">专业</td>
                <td class="table-td">{{ userInfo.proName }}</td>
              </tr>
              <tr>
                <td class="table-td1">待缴金额</td>
                <td class="table-td">
                  <span class="amount">{{ params.totalFee*0.01 }}</span
                  >元
                </td>
              </tr>
              <tr>
                <td class="table-td1">缴费类型</td>
                <td class="table-td">{{ params.subject }}</td>
              </tr>
            </table>
          </div>
          <div class="text-center">
            <button
              class="btn btn-default"
              type="submit"
              v-if="url"
              @click="gotoPay"
            >
              <i class="iconfont icon-youjiantou margin-r-10"></i>去缴费
            </button>
          </div>
        </div>

        <form :action="url" method="post" target="_blank" v-show="false">
          <input type="text" name="appFlag" v-model="params.appFlag" />
          <input type="text" name="appOrderNo" v-model="params.appOrderNo" />
          <input type="text" name="appid" v-model="params.appid" />
          <input type="text" name="body" v-model="params.body" />
          <input
            type="text"
            name="contentThrough"
            v-model="params.contentThrough"
          />
          <input type="text" name="nonceStr" v-model="params.nonceStr" />
          <input type="text" name="sign" v-model="params.sign" />
          <input type="text" name="subject" v-model="params.subject" />
          <input type="text" name="t" v-model="params.t" />
          <input type="text" name="totalFee" v-model="params.totalFee" />
          <input type="text" name="idno" v-model="params.idno" />
          <input type="text" name="name" v-model="params.name" />
          <input type="text" name="phone" v-model="params.phone" />
          <input type="text" name="studyCenter" v-model="params.studyCenter" />
          <input type="text" name="grade" v-model="params.grade" />
          <input type="text" name="collegeName" v-model="params.collegeName" />
          <input type="text" name="collegeCode" v-model="params.collegeCode" />
          <input type="submit" ref="submit" value="提交" />
        </form>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "orderPay",
  data: function () {
    return {
      url: '',
      params: null,
      paySpinning:false
    };
  },

  computed: {
    ...mapState(["city", "userInfo"]),
  },

  mounted(){
    if(localStorage.getItem('Url')){
      this.url = localStorage.getItem('Url')
      // console.log(this.url,'this.params')
    }
    
    if(JSON.parse(localStorage.getItem('params'))){
      this.params = JSON.parse(localStorage.getItem('params'))
      // console.log(this.params,'this.params')
    }
  },
  methods: {
    gotoPay() {
      this.$refs.submit.click();
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.payment {
  background: $bgcontent;
  padding: 28px;
  min-height: 640px;

  .paydetail {
    height: 68px;
    line-height: 68px;
    background: #fff;
    border: 1px solid #f2f2f2;
    margin-left: 20px;
  }

  .radio-inline {
    margin-right: 50px;
    margin-left: 15px;
  }

  .costs {
    margin-top: 30px;

    p {
      margin-bottom: 20px;
    }

    .amount {
      font-size: 36px;
      color: #fd9418;
      margin-bottom: 20px;
    }

    .paydes {
      color: #999;
    }
  }

  .form-horizontal {
    margin-top: 30px;
  }

  .btn {
    width: 154px;
    height: 42px;
    line-height: 42px;
    background: $bgColor;
    color: #fff;
    padding: 0;
  }
}

.pays {
  width: 400px;
  margin: 0 auto;
}

.content {
  background-color: #fff;
  padding: 28px;
}

.tablebg {
  border: 1px solid #efefef;
  padding: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.table th, .table td {
  border-top: none;
}

.paytitle {
  font-size: 16px;
  font-weight: bold;
}

.table-td1 {
  color: #999;
}

.margin-r-10 {
  margin-right: 5px;
}

.amount {
  color: $bgColor;
  font-weight: bold;
}

.placeholder {
  width: 100%;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/orderPay.vue